import { sentenceCase } from 'change-case';
import { filter } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
// material
import {
  Button,
  Card,
  Checkbox,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
  RadioGroup,
  Stack,
  Tab,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TablePagination,
  TableRow,
  Tabs,
  Typography
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { Box } from '@mui/system';
import { format } from 'date-fns';
// components
import { useDispatch } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import BrudCrumbs from '../../components/BreadCrumbs';
import Label from '../../components/Label';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import Scrollbar from '../../components/Scrollbar';

import SearchNotFound from '../../components/SearchNotFound';
import { UserListHead, UserListToolbar, UserMoreMenu } from '../../components/_dashboard/user';
//
import { fDate, fDateNew } from '../../utils/formatTime';
import USERLIST from '../../_mocks_/user';
import useUserSelector from '../../store/Slice/User/UserSelector';
import { getUserList, getUserViewList } from '../../store/Slice/User/UserSlice';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import {
  deleteRowApi,
  saveApiData,
  getAccessLevelData,
  getStateData,
  getDepartmentList
} from '../../store/Slice/Global/GlobalSlice';
import { UserApi } from '../../utils/Apis';
import { getReportingManagerList } from '../../store/Slice/Onboarding/OnboardingSlice';
import SimplePagination from '../../components/SimplePagination';
import useDebounce from '../../utils/useDebounce';
import RevenueService from '../services/RevenueService';
import PartnerHierarchyPage from '../OnBoarding/PartnerHierarchyComponent';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'id', label: 'User Id', alignRight: false },
  { id: 'name', label: 'USER NAME', alignRight: false },
  { id: 'users', label: 'USER EMAIL', alignRight: false },
  { id: 'category', label: 'DEPARTMENT', alignRight: false },
  // { id: 'roleLavel', label: 'LEVEL', alignRight: false },
  // { id: 'city', label: 'BRANCH', alignRight: false },
  { id: 'roleLavel', label: 'ACCESS LEVEL', alignRight: false },
  { id: 'created', label: 'Last Update', alignRight: false },
  { id: 'active', label: 'ACTIVE', alignRight: false },
  { id: '', label: 'ACTION' }
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query = '') {
  const list = Array.isArray(array) ? array : [];
  const stabilizedThis = list.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0] || {}, b[0] || {});
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  const q = String(query || '')
    .trim()
    .toLowerCase();
  if (q) {
    return list.filter((_user) => {
      const name = (_user && (_user.name ?? _user.userName ?? _user.user_name ?? '')) || '';
      return String(name).toLowerCase().includes(q);
    });
  }

  return stabilizedThis.map((el) => el[0]);
}
/**
 * Represents a book.
 * @constructor
 * @param {string} title - The title of the book.
 * @param {string} author - The author of the book.
 */
export default function Users() {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('desc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [tabValue, setTabValue] = useState(0);
  const [typeIdValue, setTypeIdValue] = useState(304);
  const [openDeleteUser, setOpenDeleteUser] = useState(false);
  const [selectedDeleteUserId, setSelectedDeleteUserId] = useState(null);
  const [hasNextPage, setHasNextPage] = useState(true);

  const [filterState, setFilterState] = useState({
    product: ' ',
    productId: null,
    productArray: [],
    city: null,
    cityId: null,
    cityArray: [],
    isAccordionItemSelected: '',
    isActive: '',
    statusId: null,
    statusArray: [],
    employmentType: ' ',
    employmentTypeId: null,
    employmentTypeArray: [],
    departmentId: null,
    branchId: null,
    accessLevelId: null
  });

  const dispatch = useDispatch();
  const { UserListData } = useUserSelector();
  const { LoginData } = useLoginSelector();
  const navigate = useNavigate();
  const debouncedSearch = useDebounce(filterName, 600);
  const { DownloadUserRecord } = RevenueService;

  // console.log('selected rows', selected[0]);
  const getStateList = () => {
    const data = {
      countryId: 101
    };
    dispatch(getStateData(data));
  };
  useEffect(() => {
    getStateList();
  }, []);

  const handledeleteUserRow = (userId) => {
    // console.log('delete user id', userId);
    setSelectedDeleteUserId(userId);
    setOpenDeleteUser(true);
  };

  const deleteUserRow = useCallback(
    async (userIdToDelete) => {
      if (!userIdToDelete) return;
      const credentials = {
        userId: userIdToDelete,
        loggedInUserId: LoginData?.userId
      };
      const endpoint = `${UserApi?.deleteUser}`;
      const result = await dispatch(deleteRowApi(endpoint, credentials));
      setOpenDeleteUser(false);
      if (result?.status === 'success') {
        navigate('/users/');
        getUserListApi();
      }
    },
    [dispatch, navigate, LoginData?.userId]
  );
  const viewUserRow = useCallback(
    async ({ userId, action }) => {
      // console.log('view user id', userId, action);
      const endpoint = `${UserApi?.viewUser}/${userId}?loggedInUserId=${LoginData?.userId}`;
      const result = await dispatch(getUserViewList(endpoint));

      // console.log('sss view user result', result);

      if (result && action === 'view') {
        navigate(`/users/view/${userId}`);
      } else if (result && action === 'edit') {
        navigate(`/users/edit/${userId}`);
      }
    },
    [dispatch, navigate, LoginData?.userId]
  );

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = UserListData.map((n) => n.userId);
      setSelected(newSelecteds);
    } else {
      setSelected([]);
    }
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = [...selected, id];
    } else {
      newSelected = selected.filter((item) => item !== id);
    }

    setSelected(newSelected);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - UserListData.length) : 0;

  const filteredUsers = applySortFilter(UserListData, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredUsers.length === 0;

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0
    }
  }));
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      fontSize: 13,
      fontWeight: 'normal',
      padding: '6px'
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 11,
      padding: 4
    }
  }));

  const handleExport = async (type) => {
    // console.log('Selected:', type);
    if (selected.length > 0) {
      type = null;
    }
    const credential = {
      userIds: selected,
      typeId: type,
      loggedInUserId: LoginData?.userId
    };

    try {
      const response = await DownloadUserRecord(credential, LoginData?.jwt);

      const contentType = response.headers.get('content-type');
      // console.log('content-type =>', contentType);

      const blob = await response.blob();
      // console.log('response222', blob);
      let fileName = `userDataDownload_${format(new Date(), 'dd-MM-yyyy_HH-mm-ss')}`;
      let mimeType = contentType;

      fileName += '.xlsx';
      mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

      const url = window.URL.createObjectURL(new Blob([blob], { type: mimeType }));

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Export error:', error);
    }
  };

  // Hide the ACTION column for Partner view (typeIdValue 302)
  const currentTableHead =
    typeIdValue === 302 ? TABLE_HEAD.filter((h) => h.label !== 'ACTION') : TABLE_HEAD;

  const getUserListApi = useCallback(() => {
    const credentials = {
      companyId: LoginData?.companyId,
      loggedInUserId: LoginData?.userId,
      accessLevelId: LoginData?.accessLevelId,
      stageId: 58,
      filterModel: {
        departmentId: filterState?.departmentId ?? null,
        branchId: filterState?.branchId ?? null,
        accessLevelId: filterState?.accessLevelId ?? null,
        isActive: filterState?.isActive ?? null,
        typeId: typeIdValue
      },
      entityListRequestModel: {
        searchLiteral: debouncedSearch?.length >= 2 ? debouncedSearch : '',
        pageSize: rowsPerPage,
        pageNumber: page + 1,
        sortOrder: order
      }
    };
    // console.log('getUserListApi credentials', credentials);
    dispatch(getUserList(credentials));
  }, [dispatch, typeIdValue, LoginData, debouncedSearch, order, filterState, rowsPerPage, page]);

  useEffect(() => {
    getUserListApi();
  }, [getUserListApi]);

  // dispatch(getUserListApi());

  // console.log('sss UserListData', UserListData);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const fetchAccessLevel = useCallback(() => {
    dispatch(getAccessLevelData(LoginData?.companyId));
  }, [dispatch, LoginData]);

  useEffect(() => {
    fetchAccessLevel();
  }, [fetchAccessLevel]);

  useEffect(() => {
    if (!UserListData) {
      setHasNextPage(true);
      return;
    }
    // If API returns only current page items:
    setHasNextPage(UserListData.length >= rowsPerPage);
  }, [UserListData, rowsPerPage]);

  useEffect(() => {
    setPage(0);
  }, [filterName, rowsPerPage, typeIdValue, tabValue, filterState]);

  const getDepartmentAPi = useCallback(() => {
    if (!LoginData) return '';
    const credential = {
      companyId: LoginData?.companyId
    };
    dispatch(getDepartmentList(credential));
  }, [LoginData]);

  useEffect(() => {
    getDepartmentAPi();
  }, [getDepartmentAPi]);

  useEffect(() => {
    setPage(0);
  }, [debouncedSearch]);

  return (
    <Page title="Kpros by Kalolytic Solutions || User">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="List of Users" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>
          <Tabs
            value={tabValue}
            onChange={handleChange}
            className="tabOuter"
            aria-label="basic tabs example"
            classes={{ indicator: 'tabIndicator' }}
          >
            <Tab
              label="Employee"
              {...a11yProps(0)}
              classes={{ selected: 'tabSelected', root: 'tabDefault' }}
              onClick={() => setTypeIdValue(304)}
            />
            {/* <Tab
                label="Partner"
                {...a11yProps(1)}
                classes={{ selected: 'tabSelected', root: 'tabDefault' }}
                onClick={() => setTypeIdValue(302)}
              /> */}
            <Tab
              label="Hierarchy"
              {...a11yProps(1)}
              classes={{ selected: 'tabSelected', root: 'tabDefault' }}
              // onClick={() => setTypeIdValue(302)}
              disabled={selected?.length !== 1}
            />
          </Tabs>
          <TabPanel value={tabValue} index={0}>
            <Card>
              <UserListToolbar
                numSelected={selected.length}
                filterName={filterName}
                onFilterName={handleFilterByName}
                parent="users"
                filterState={filterState}
                setFilterState={setFilterState}
                typeIdValue={typeIdValue}
                handleExport={handleExport}
              />

              <Scrollbar>
                <TableContainer
                  sx={{
                    minWidth: 800,
                    overflow: 'auto',
                    height: '50vh'
                  }}
                >
                  <Table>
                    <UserListHead
                      order={order}
                      orderBy={orderBy}
                      headLabel={currentTableHead}
                      rowCount={UserListData.length}
                      numSelected={selected.length}
                      onRequestSort={handleRequestSort}
                      onSelectAllClick={handleSelectAllClick}
                      isCheckBox="true"
                    />
                    <TableBody>
                      {filteredUsers
                        // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row) => {
                          const {
                            userId,
                            userName,
                            email,
                            departmentId,
                            level,
                            branchId,
                            accessLevel,
                            departmentName,
                            createdOn,
                            active
                          } = row;
                          // console.log('users', users);
                          const isItemSelected = selected.includes(userId);

                          return (
                            <StyledTableRow
                              hover
                              key={userId}
                              tabIndex={-1}
                              role="checkbox"
                              selected={isItemSelected}
                              aria-checked={isItemSelected}
                            >
                              <TableCell padding="checkbox">
                                <Checkbox
                                  checked={isItemSelected}
                                  onChange={(event) => handleClick(event, userId)}
                                />
                              </TableCell>

                              <StyledTableCell align="left">{userId}</StyledTableCell>
                              <StyledTableCell align="left">{userName}</StyledTableCell>
                              <StyledTableCell align="left">{email}</StyledTableCell>
                              <StyledTableCell align="left">{departmentName}</StyledTableCell>
                              {/* <StyledTableCell align="left">{level}</StyledTableCell> */}
                              {/* <StyledTableCell align="left">{branchId}</StyledTableCell> */}
                              <StyledTableCell align="left">{accessLevel}</StyledTableCell>
                              <StyledTableCell align="left">{fDateNew(createdOn)}</StyledTableCell>
                              <StyledTableCell align="left">
                                <Label
                                  variant="ghost"
                                  color={
                                    (active === 'No' && 'error') ||
                                    (active === 'Yes' && 'success') ||
                                    'success'
                                  }
                                >
                                  {/* {sentenceCase(active)} */}
                                  {/* {active} */}
                                  {active === true ? 'Yes' : 'No'}
                                </Label>
                              </StyledTableCell>

                              <StyledTableCell align="">
                                <UserMoreMenu
                                  rowId={userId}
                                  parent="users"
                                  deleteUserRow={handledeleteUserRow}
                                  viewUserRow={viewUserRow}
                                />
                              </StyledTableCell>
                            </StyledTableRow>
                          );
                        })}
                      {/* {emptyRows > 0 && (
                          <TableRow style={{ height: 53 * emptyRows }}>
                            <StyledTableCell colSpan={6} />
                          </TableRow>
                        )} */}
                    </TableBody>
                    {isUserNotFound && (
                      <TableBody>
                        <TableRow>
                          <StyledTableCell align="center" colSpan={6} sx={{ py: 3 }}>
                            <SearchNotFound searchQuery={filterName} />
                          </StyledTableCell>
                        </TableRow>
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
              </Scrollbar>
            </Card>
            {/* <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={UserListData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              /> */}
            <SimplePagination page={page} setPage={setPage} hasNextPage={hasNextPage} />
          </TabPanel>

          {/* ================= INVOICE TAB (API DATA) ================= */}
          <TabPanel value={tabValue} index={2}>
            <Card>
              <UserListToolbar
                numSelected={selected.length}
                filterName={filterName}
                onFilterName={handleFilterByName}
                parent="users"
                filterState={filterState}
                setFilterState={setFilterState}
                typeIdValue={typeIdValue}
                handleExport={handleExport}
              />

              <Scrollbar>
                <TableContainer
                  sx={{
                    minWidth: 800,
                    // height: '70vh',
                    overflow: 'auto'
                  }}
                >
                  <Table>
                    <UserListHead
                      order={order}
                      orderBy={orderBy}
                      headLabel={currentTableHead}
                      rowCount={USERLIST.length}
                      numSelected={selected.length}
                      onRequestSort={handleRequestSort}
                      onSelectAllClick={handleSelectAllClick}
                      isCheckBox="true"
                    />
                    <TableBody>
                      {filteredUsers
                        // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row) => {
                          const {
                            userId,
                            userName,
                            email,
                            departmentId,
                            departmentName,
                            level,
                            branchId,
                            accessLevel,
                            createdOn,
                            active
                          } = row;
                          // console.log('users', users);
                          const isItemSelected = selected.indexOf(row) !== -1;

                          return (
                            <StyledTableRow
                              hover
                              key={userId}
                              tabIndex={-1}
                              role="checkbox"
                              selected={isItemSelected}
                              aria-checked={isItemSelected}
                            >
                              <TableCell padding="checkbox">
                                <Checkbox
                                  checked={isItemSelected}
                                  onChange={(event) => handleClick(event, row)}
                                />
                              </TableCell>

                              <StyledTableCell align="left">{userId}</StyledTableCell>
                              <StyledTableCell align="left">{userName}</StyledTableCell>
                              <StyledTableCell align="left">{email}</StyledTableCell>
                              <StyledTableCell align="left">{departmentName}</StyledTableCell>
                              {/* <StyledTableCell align="left">{level}</StyledTableCell> */}
                              {/* <StyledTableCell align="left">{branchId}</StyledTableCell> */}
                              <StyledTableCell align="left">{accessLevel}</StyledTableCell>
                              <StyledTableCell align="left">{createdOn}</StyledTableCell>
                              <StyledTableCell align="left">
                                <Label
                                  variant="ghost"
                                  color={
                                    (active === 'No' && 'error') ||
                                    (active === 'Yes' && 'success') ||
                                    'success'
                                  }
                                >
                                  {/* {sentenceCase(active)} */}
                                  {/* {active} */}
                                  {active === true ? 'Yes' : 'No'}
                                </Label>
                              </StyledTableCell>

                              <StyledTableCell align="">
                                {/* <UserMoreMenu rowId={userId} parent="users" /> */}
                              </StyledTableCell>
                            </StyledTableRow>
                          );
                        })}
                      {emptyRows > 0 && (
                        <TableRow style={{ height: 53 * emptyRows }}>
                          <StyledTableCell colSpan={6} />
                        </TableRow>
                      )}
                    </TableBody>
                    {isUserNotFound && (
                      <TableBody>
                        <TableRow>
                          <StyledTableCell align="center" colSpan={6} sx={{ py: 3 }}>
                            <SearchNotFound searchQuery={filterName} />
                          </StyledTableCell>
                        </TableRow>
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
              </Scrollbar>

              {/* <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={UserListData.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                /> */}
              <SimplePagination page={page} setPage={setPage} hasNextPage={hasNextPage} />
            </Card>
          </TabPanel>
          {/* ================= heirarchy level ================= */}
          <TabPanel value={tabValue} index={1}>
            <PartnerHierarchyPage partnerId={selected[0]} />
          </TabPanel>
        </Box>
        <Dialog open={openDeleteUser} onClose={(e) => setOpenDeleteUser(false)} fullWidth>
          <DialogTitle className="popupTitle">
            <Typography variant="h6">Sure you want to Delete?</Typography>
            <IconButton onClick={(e) => setOpenDeleteUser(false)} size="small">
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogActions disableSpacing={false}>
            <Button
              onClick={() => deleteUserRow(selectedDeleteUserId)}
              variant="contained"
              className="mainBtn"
            >
              Okay
            </Button>
            <Button
              onClick={(e) => setOpenDeleteUser(false)}
              variant="contained"
              className="mainBtn"
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Page>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ paddingTop: '1rem' }}>
          <Card>{children}</Card>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}
